import React, { useState } from "react";
import AdminLayout from "../../components/AdminLayout";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Shield, Check } from "lucide-react";
import { toast } from "sonner";

export default function AdminAccess() {
  const { user, refresh } = useAuth();
  const [secret, setSecret] = useState("");
  const [loading, setLoading] = useState(false);

  const promote = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/promote", { secret });
      toast.success("You're now an admin.");
      await refresh();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid secret");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="eyebrow mb-2">Access</div>
      <h1 className="font-display text-4xl font-bold tracking-tight">Admin access</h1>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="card-soft p-7">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-terra/10 grid place-items-center text-terra"><Shield size={18} /></div>
            <div>
              <div className="font-display text-xl font-semibold">Your role</div>
              <div className="text-xs text-inkSoft">{user?.email}</div>
            </div>
          </div>
          <div className="mt-4 flex items-center gap-2">
            {user?.is_admin ? (
              <span className="tag tag-accent inline-flex items-center gap-1"><Check size={12} /> Admin</span>
            ) : (
              <span className="tag">Customer</span>
            )}
          </div>
          <p className="mt-4 text-sm text-inkSoft">The first user to sign up is automatically promoted to admin. Anyone else can be promoted by entering the secret.</p>
        </div>

        <form onSubmit={promote} className="card-soft p-7" data-testid="admin-promote-form">
          <div className="font-display text-xl font-semibold mb-2">Promote yourself</div>
          <p className="text-sm text-inkSoft">Enter the agency-level promotion secret (set via <span className="font-mono">ADMIN_PROMOTE_SECRET</span> on the backend) to grant your account admin rights.</p>
          <input
            type="password"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            placeholder="Promotion secret"
            className="mt-4 w-full h-11 px-4 rounded-xl border border-line bg-white text-sm outline-none focus:border-ink"
            data-testid="admin-promote-secret"
          />
          <button type="submit" disabled={loading || !secret} className="btn-primary text-sm mt-4 w-full justify-center" data-testid="admin-promote-submit">
            {loading ? "Promoting…" : "Promote to admin"}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}
